export default "__VITE_PUBLIC_ASSET__5cd73ca3__"